/* sb-csoon-parallax.js — scroll parallax for the coming-soon hero footage
   (hero_parallax setting). The frosted glass panel scrolls normally with the
   page; the video behind it drifts at a slower rate (SPEED), so the footage
   appears pinned deeper in the scene. The video element bleeds 20% beyond
   the stage top/bottom (CSS) and the shift is clamped inside that bleed, so
   no empty regions can appear; the stage grade (not parallaxed) keeps the
   porcelain dissolve over the seam into the next section. Static under
   prefers-reduced-motion. Idempotent, re-inits on shopify:section:load. */
(function () {
  'use strict';

  var SPEED = 0.4;
  var MAX_BLEED = 0.18; /* of stage height — CSS bleeds 20%, keep a margin */

  function initStage(stage) {
    if (stage.dataset.sbParBound === 'true') return;
    stage.dataset.sbParBound = 'true';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (reduce.matches) {
          stage.style.removeProperty('--sb-csoon-par');
          return;
        }
        var rect = stage.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var max = rect.height * MAX_BLEED;
        var shift = -rect.top * SPEED;
        shift = Math.max(-max, Math.min(max, shift));
        stage.style.setProperty('--sb-csoon-par', shift.toFixed(1) + 'px');
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (typeof reduce.addEventListener === 'function') {
      reduce.addEventListener('change', onScroll);
    } else if (typeof reduce.addListener === 'function') {
      reduce.addListener(onScroll);
    }
    onScroll();
  }

  function initAll(scope) {
    var stages = (scope || document).querySelectorAll('.sb-csoon__stage--parallax');
    Array.prototype.forEach.call(stages, initStage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
